/**
 * @Description 选址-解释说明
 */
import { FC, useContext, useMemo } from 'react';
import { markTypeEnum } from '@/views/iterate/pages/siteselectionmapb/ts-config';
import { globalOpeningAreaAlias } from '@/common/utils/ways';
import UserInfoContext from '@/layout/context';
import { isNotEmptyAny } from '@lhb/func';



// 预测文案
const predictSaleDescription = '预测营业额：基于历史门店经营情况，通过大数据计算得出，最终具体点位营业额预估会受到店铺位置等级、视认性、接近性、引流聚客和“经营”等因素影响，以上数据仅供参考';

const SiteMapExplain:FC<{
  markType: number;
  isPredictSale: boolean;
  shareParams?:any;
}> = ({
  markType,
  isPredictSale,
  shareParams = {}
}) => {
  const { tenantInfo: { globalAliasItemVOs } } = useContext(UserInfoContext); // 租户信息

  const openingAreaTaskAlias = useMemo(() => {
    if (isNotEmptyAny(shareParams) && shareParams?.globalAliasItemVOs) return globalOpeningAreaAlias(shareParams.globalAliasItemVOs);
    return globalOpeningAreaAlias(globalAliasItemVOs);
  }, [globalAliasItemVOs, shareParams]);

  // 四维文案，四条描述
  const fourDimensionDescription = [
    `人口客群：根据周边的居住人口、办公人口、商场客流人口计算，评分越高代表该${openingAreaTaskAlias}人越多。`,
    `区域特征：根据周边的商业、住宅、办公、交通、生活服务等计算，评分越高代表${openingAreaTaskAlias}配套越完善。`,
    `消费能力：根据周边的餐饮消费客单价、房价计算，评分越高代表${openingAreaTaskAlias}消费能力越强。`,
    `行业评分：根据周边的同行业门店数、开闭店数计算，评分越高代表该${openingAreaTaskAlias}内此行业经营氛围越好。`,
  ];

  // 五维文案，五条描述
  const fiveDimensionDescription = [
    `人口客群：根据周边500m的居住人口、办公人口、商场客流人口计算，评分越高代表该${openingAreaTaskAlias}人越多。`,
    `区域特征：根据周边500m的商业、住宅、办公、交通、生活服务等计算，评分越高代表${openingAreaTaskAlias}配套越完善。`,
    `消费能力：根据周边500m的餐饮消费客单价、房价计算，评分越高代表${openingAreaTaskAlias}消费能力越强。`,
    `业态氛围：根据周边500m的同行业门店、协同业态门店计算，评分越高代表该${openingAreaTaskAlias}内品牌经营氛围越好。`,
    `销售潜力：基于历史门店经营情况，通过大数据测算${openingAreaTaskAlias}内品牌营业额，评分越高代表该${openingAreaTaskAlias}内品牌经营氛围越好。`,
  ];

  // 六维文案，五维基础上增加一条描述
  const sixDimensionDescription = [
    ...fiveDimensionDescription,
    `行业评分：根据周边的同行业门店数、开闭店数计算，评分越高代表该${openingAreaTaskAlias}内此行业经营氛围越好。`
  ];
  const dimensionDescription = useMemo(() => {
    if (markType === markTypeEnum.six) {
      return sixDimensionDescription;
    } else if (markType === markTypeEnum.five) {
      return fiveDimensionDescription;
    } else {
      return fourDimensionDescription;
    }
  }, [markType]);

  return (
    <div style={{ color: 'rgba(0, 0, 0, 0.85)' }}>
      <div>指标说明：</div>
      {dimensionDescription.map((itm: any, idx: number) => (
        <div key={idx} className='mt-12'>{itm}</div>
      ))}
      {isPredictSale ? <div className='mt-12'>{predictSaleDescription}
      </div> : <></>}
    </div>
  );
};
export default SiteMapExplain;
